
define('ldsh!modules/form_editor/templates/custom_terms', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (isAMP) { ;
__p += '\n<div class="col-sm-9 js-control js-items predef-item">\n  <label class="checkbox-terms checkbox-inline">\n    <input type="checkbox"\n        on="change:AMP.setState({\n          ' +
((__t = ( ampStateId )) == null ? '' : __t) +
': {\n            choiceChecked: event.checked == true ?\n            ' +
((__t = ( ampStateId )) == null ? '' : __t) +
'.choiceChecked + 1 :\n            ' +
((__t = ( ampStateId )) == null ? '' : __t) +
'.choiceChecked - 1\n          }\n        })"\n        name="' +
((__t = ( nameAttr )) == null ? '' : __t) +
'"\n        class="' +
((__t = ( isRequired ? 'form-element-required' : '' )) == null ? '' : __t) +
' js-terms"\n        id="' +
((__t = ( elementId )) == null ? '' : __t) +
'"\n        ' +
((__t = ( isRequired  ? 'required' : '')) == null ? '' : __t) +
'\n    /> <span class="terms-text">' +
((__t = ( termsText )) == null ? '' : __t) +
'</span>\n  </label>\n</div>\n<span class="hidden-no-amp"\n  validation-for="' +
((__t = ( ampStateId )) == null ? '' : __t) +
'-anythingChecked"\n  visible-when-invalid="valueMissing">' +
((__t = (errorMessage)) == null ? '' : __t) +
'</span>\n\n<input id="' +
((__t = ( ampStateId )) == null ? '' : __t) +
'-anythingChecked"\n  value="' +
((__t = ( ampStateId )) == null ? '' : __t) +
'"\n  type="checkbox"\n  data-amp-state-id="' +
((__t = ( ampStateId )) == null ? '' : __t) +
'"\n  data-amp-state-content=\'{"choiceChecked": 0}\'\n  [checked]="' +
((__t = ( ampStateId )) == null ? '' : __t) +
'.choiceChecked > 0 ? \'checked\' : \'\'"\n  style="display:none"\n' +
((__t = ( isRequired ? 'required' : '' )) == null ? '' : __t) +
'\n/>\n';
 } else { ;
__p += '\n<div class="col-sm-9 js-control js-items predef-item">\n  <label class="checkbox-terms checkbox-inline">\n    <input type="checkbox"\n           name="' +
((__t = ( nameAttr )) == null ? '' : __t) +
'"\n           class="' +
((__t = ( isRequired ? 'form-element-required' : '' )) == null ? '' : __t) +
' js-terms"\n           id="' +
((__t = ( elementId )) == null ? '' : __t) +
'"\n    /> <span class="terms-text">' +
((__t = ( termsText )) == null ? '' : __t) +
'</span>\n  </label>\n</div>\n';
 } ;
__p += '\n';

}
return __p
};});

